module.exports = __webpack_public_path__ + "img/chingaling-logo.8ad671ff.png";